import { useEffect } from 'react';
import { CssBaseline } from '@mui/material';
import { AppRoutes } from '@/routes';

const hideInitialSplash = () => {
  const splash = document.getElementById('initial-splash');
  if (splash) {
    splash.classList.add('hidden');
    setTimeout(() => {
      splash.remove();
    }, 300);
  }
};

function App() {
  useEffect(() => {
    hideInitialSplash();
  }, []);

  return (
    <>
      <CssBaseline />
      <AppRoutes />
    </>
  );
}

export default App;
